import * as ai from './ai';
import * as analysisCsvs from './analysisCsvs';
import * as analysisHistory from './analysisHistory';
import * as analysisPdfs from './analysisPdfs';
import * as analysisResults from './analysisResults';
import * as analysisSets from './analysisSets';
import * as assemblyGroups from './assemblyGroups';
import * as assistant from './assistant';
import * as batches from './batches';
import * as bundles from './bundles';
import * as canary from './canary';
import * as componentDesigns from './componentDesigns';
import * as componentDesignSummaries from './componentDesignSummaries';
import * as componentMacros from './componentMacros';
import * as countUtilities from './countUtilities';
import * as defaults from './defaults';
import * as dimensions from './dimensions';
import * as directories from './directories';
import * as estimates from './estimates';
import * as hangerConnectors from './hangerConnectors';
import * as hangerPrices from './hangerPrices';
import * as jackGirderConnections from './jackGirderConnections';
import * as lines from './lines';
import * as loadSets from './loadSets';
import * as lumberPrices from './lumberPrices';
import * as lumbers from './lumbers';
import * as materialLists from './organizationMaterialSets';
import * as pdfs from './pdfs';
import * as platePairs from './platePairs';
import * as platePrices from './platePrices';
import * as presets from './presets';
import * as productionComponentInstanceBuildLogs from './productionComponentInstanceBuildLogs';
import * as productionComponentInstances from './productionComponentInstances';
import * as productionGroups from './productionGroups';
import * as productionOutputPresets from './productionOutputPresets';
import * as projectFiles from './projectFiles';
import * as projects from './projects';
import * as revit from './revit';
import * as scheduleGroups from './scheduleGroups';
import * as scheduleLineGroups from './scheduleLineGroups';
import * as settings from './settings';
import * as sharedComponentSets from './sharedComponentSets';
import * as sortingFiles from './sortingFiles';
import * as stations from './stations';
import * as support from './support';
import * as trailers from './trailers';
import * as truckDrivers from './truckDrivers';
import * as truckloads from './truckloads';
import * as usageData from './usageData';
import * as userSettings from './userSettings';

export default {
  ai,
  analysisCsvs,
  analysisHistory,
  analysisPdfs,
  analysisResults,
  analysisSets,
  assemblyGroups,
  assistant,
  batches,
  bundles,
  canary,
  componentDesigns,
  componentDesignSummaries,
  countUtilities,
  componentMacros,
  defaults,
  dimensions,
  directories,
  estimates,
  hangerConnectors,
  hangerPrices,
  jackGirderConnections,
  lines,
  loadSets,
  lumberPrices,
  lumbers,
  materialLists,
  pdfs,
  platePairs,
  platePrices,
  presets,
  projectFiles,
  sharedComponentSets,
  productionComponentInstanceBuildLogs,
  productionComponentInstances,
  productionGroups,
  productionOutputPresets,
  projects,
  revit,
  scheduleGroups,
  scheduleLineGroups,
  settings,
  sortingFiles,
  stations,
  support,
  trailers,
  truckDrivers,
  truckloads,
  usageData,
  userSettings,
};
